import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
declare var ko: any;

export class mailingListEdit_template extends vnTemplate {

    public welcomeEmailSelector: filterDropdown_template;
    public unsubscriptionEmailSelector: filterDropdown_template;

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Mailing List</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group row">
                        <label for="idMailingList" class="form-label form-label form-label-box">Title</label>
                        <input type="text" class="input-text" data-bind="value: name">
                    </div>
                    <div class="form-group row">
                        <label for="label" class="form-label form-label form-label-box">Description</label>
                        <input type="text" class="input-text" data-bind="value: description">
                    </div>
                    <div class="form-group row">
                        <label for="label" class="form-label form-label form-label-box">Reference</label>
                        <input type="text" class="input-text" data-bind="enable: false, value: reference">
                    </div>
                    <div class="form-group row">
                        <input type="checkbox" data-bind="checked: isActive" id="active">
                        <label class="icon i-check" for="active">Active</label>   
                    </div>
                    <div class="form-group row">
                        <input type="checkbox" data-bind="checked: isDefault, disable: true" id="default">
                        <label class="icon i-check" for="default">Is Default</label>   
                    </div>
                    <div class="form-group row">
                        <input type="checkbox" data-bind="checked: isPrimary, disable: true" id="primary">
                        <label class="icon i-check" for="primary">Is Primary</label>   
                    </div>
                    <div class="form-group row">
                        <label for="welcomeEmail" class="form-label">Welcome Email</label>
                        ${this.welcomeEmailSelector.getHtmlBuild()}
                    </div>
                    <div class="form-group row">
                        <label for="welcomeEmail" class="form-label">Unsubscribtion Email</label>
                        ${this.unsubscriptionEmailSelector.getHtmlBuild()}
                    </div>
                </div>      
            </div>
             <div class="form-footer">                
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div> 
            `;
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , name: ko.observable("")
            , description: ko.observable("")
            , reference: ko.observable("")
            , isActive: ko.observable("false")
            , isDefault: ko.observable("false")
            , isPrimary: ko.observable("false")
            , onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();
            },
            onClickSave: function (data, event) {
                self.onClickSave()
            }
        }
    }

    protected initPartial(): void {

        this.welcomeEmailSelector = new filterDropdown_template('welcomeEmailSelector', this.getTemplateViewModel(), this.caller);
        this.welcomeEmailSelector.setLabel('Template');
        this.welcomeEmailSelector.setDisable(true)
        
        this.unsubscriptionEmailSelector = new filterDropdown_template('unsubscriptionEmailSelector', this.getTemplateViewModel(), this.caller);
        this.unsubscriptionEmailSelector.setLabel('Template');
        this.unsubscriptionEmailSelector.setDisable(true)
    }

    protected getTemplateName(): string {
        return "mailingListEdit_template";
    }

    public getViewModelForRequest(): any {

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            description: this.getTemplateViewModel().description(),
            reference: this.getTemplateViewModel().reference(),
            isActive: this.getTemplateViewModel().isActive(),
            isPrimary: this.getTemplateViewModel().isPrimary(),
            isDefault: this.getTemplateViewModel().isDefault(),
            welcomeEmailId: this.welcomeEmailSelector.getTemplateViewModel().selectedOption,
            unsubscriptionEmailId: this.unsubscriptionEmailSelector.getTemplateViewModel().selectedOption,
        };
    }

    public setId(id){
        this.getTemplateViewModel().id(id)
    }

    public setName(name){
        this.getTemplateViewModel().name(name)
    }

    public setDescription(description){
        this.getTemplateViewModel().description(description)
    }
    
    public setReference(reference){
        this.getTemplateViewModel().reference(reference)
    }
    
    public setIsActive(isActive){
        this.getTemplateViewModel().isActive(isActive)
    }
    
    public setIsPrimary(isPrimary){
        this.getTemplateViewModel().isPrimary(isPrimary)
    }
    
    public setIsDefault(isDefault){
        this.getTemplateViewModel().isDefault(isDefault)
    }

    public setWelcomeEmails( options) {
        this.welcomeEmailSelector.setOptions(options);
    }
    
    public setUnsubscriptionEmails( options) {
        this.unsubscriptionEmailSelector.setOptions(options);
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/mailingListEdit_template.ts